import React from 'react'
import ReactDOM from 'react-dom/client'
import ThreeMIQApp from './App.jsx'
import Support from './pages/Support.jsx'
import Privacy from './pages/Privacy.jsx'
import Terms from './pages/Terms.jsx'
import './index.css'

const path = window.location.pathname
const root = ReactDOM.createRoot(document.getElementById('root'))

let component
if (path === '/support') component = React.createElement(Support)
else if (path === '/privacy') component = React.createElement(Privacy)
else if (path === '/terms') component = React.createElement(Terms)
else component = React.createElement(ThreeMIQApp)

root.render(component)
